import { render } from "./ReferenceEmails.vue?vue&type=template&id=22721422"
import script from "./ReferenceEmails.vue?vue&type=script&lang=js"
export * from "./ReferenceEmails.vue?vue&type=script&lang=js"

import "./ReferenceEmails.vue?vue&type=style&index=0&id=22721422&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__